export const CountriesQueryKeys = {
    all: ['countries'] as const
}

export const CountryPrefixesQueryKeys = {
    all: ['countries'] as const
}